import { ChannelDetails } from "@/lib/types";
import { selectActiveFirm } from "@/store/appSelectors";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { LoadingSmall } from "@/components/LoadingSmall";
import React, { useState } from "react";
import { constructChannelSchedule, PlayerSchedule } from "@/pages/player/playerDetail/PlayerScheduleDetailUtils";
import { ScheduleSection } from "@/pages/player/playerDetail/ScheduleSection";
import { PlayerTimezoneSelect } from "@/pages/player/form/PlayerTimezoneSelect";

interface Props {
  channelDetails: ChannelDetails;
}

export const ChannelScheduleDetail: React.FC<Props> = ({ channelDetails }) => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);
  const [timezone, setTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);

  const { data: channelSchedule, isFetching } = useQuery({
    queryFn: () => constructChannelSchedule(channelDetails.id, String(activeFirm?.firmGuid), timezone),
    queryKey: ["channelSchedule", timezone],
  });

  if (isFetching) {
    return <LoadingSmall />;
  }

  const s: PlayerSchedule = {
    channelConf: channelSchedule,
  };

  if (!s.channelConf) {
    return <div className="text-sm text-muted-foreground">{t("schedule.noSchedule")}</div>;
  }

  return (
    <div className="space-y-4">
      {/* @ts-ignore */}
      <PlayerTimezoneSelect field={{ value: timezone, onChange: setTimezone }} />
      {s.channelConf && <ScheduleSection conf={s.channelConf} type="channel" isOverridenByArea={s.isOverridenByArea} />}
    </div>
  );
};
